import { AttributeCollection } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import CreateNewGUID from "vagaro-website-rendering/src/components/Utilities/CreateNewGUID";
import WebDesigner from "../WebDesigner";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { SiteStyling } from "vagaro-website-rendering/src/components/Definitions/SiteStyling";
import { defaultCookieBannerText } from "vagaro-website-rendering/src/components/ComponentRenders/RenderCookieBanner";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";


type imageCacheData = {

    blobURL:string,
    fileSize:number,
    imageURL:string,
}

class ImageCache {
  maxMemory = 10000000; // 10mb

  imageToBlobDictionary: { [key: string]: imageCacheData } = {};
  imageBlobList: imageCacheData[] = [];

  usedMemory = 0;

  GetImageURL(inURL: string) {

    return inURL;

  }

  private async CacheImage(imageUrl: string) {
    try {
      const response = await fetch(imageUrl);

      const blob = await response.blob();

      if (blob) {
        const objectUrl = URL.createObjectURL(blob);

        if (!this.imageToBlobDictionary[imageUrl]) {
          this.imageToBlobDictionary[imageUrl] = {
            blobURL: objectUrl,
            fileSize: blob.size,
            imageURL: imageUrl,
          };
          this.imageBlobList.push({
            blobURL: objectUrl,
            fileSize: blob.size,
            imageURL: imageUrl,
          });
          this.usedMemory += blob.size;

          while (this.usedMemory > this.maxMemory) {
            let shift = this.imageBlobList.shift();
            if (shift) {
              this.usedMemory -= shift.fileSize;
              delete this.imageToBlobDictionary[shift.imageURL];
            } else {
              break;
            }
          }
        }
      }
    } catch (e) {

     // console.warn("Failed to cache image: " + imageUrl);
     // console.warn("err: " + e);
    }
  }


}

export class pageFolder{

    name: string = "";
    id: string = "";
    folderId: string ="";
    isFolder:boolean = true;

    constructor(name:string,folderId:string,isFolder:boolean,id:string|null =null){
        this.name = name;
        this.id = id??CreateNewGUID();
        this.folderId = folderId;
        this.isFolder = isFolder;
    }



    static CreateNewFolder(newFolderName:string = "New Folder"){
        let newFolder= new pageFolder(newFolderName,"",true);

        return newFolder;
    }

    static CreateNewPage(newPageName:string = "New Folder",folderId:string=""){
        let newPage= new pageFolder(newPageName,folderId,false);

        return newPage

    }
}

export type EditorSettings = {
    advancedMenuIsModular:boolean, //weather the advanced menu shows every option or is modular
    editColorIndex:number; // adjust theme
    showAddSectionButtons:boolean; // displays the + buttons to add sections without dragging and droping
    disableAnimations:boolean; // disable transistions on the canvas
    autoSave:boolean; // auto save every 10 seconds
    autoSaveFrequency:number; // how often to auto save

    promptForTemplates:boolean; // when adding a section prompt the user to select a template
    dragSensitivity: number,//how far the mouse/touch must move before a drag is initiated
    autoExpandCollapseRightMenu:boolean,
    opimizeRendering:boolean,
}

export type BusinessValidTabs = {
  isPackageShow: boolean;
  isShowBookNowTab: boolean;
  isShowClassTab: boolean;
  isShowGCTab: boolean;
  isShowMembership: boolean;
  isShowProductTab: boolean;
  isShowServiceTab: boolean;
  isShowDailyDeals: boolean;
};


export type SiteData = {

  vagaroURL?:string;
    // accessToken:string,
    currentPageId:string,
    lastPublishDate:string,
    // businessId: string;
    // templateId:string;
    siteName: string,
    cdnUrl:string,
    AdminCDNURL:string,
    homePageId:string,
    imageCache:ImageCache,
    pages: PageData[],

    //store the layoutString of header and footer to compare when saving instead of listening to every event
    prevHeader:string,
    prevFooter:string,


    isStyleSaveDirty?:boolean, //updated when global style is changed
    isStylePublishDirty?:boolean, //updated when global style is changed
    isHeaderPublishDirty?:boolean,
    isFooterPublishDirty?:boolean,
    isPageListPublishDirty?:boolean, //updated on any page change (structure, name, url ect)
    isViewAllowed:boolean,
    isModifyAllowed:boolean,
    title:string,
    siteStyling: SiteStyling;

    editorSettings:EditorSettings,
    onUpdateStyle:Function,
    onUpdateCustomCSS:Function,
    designer:WebDesigner|null, // back door to the webdesigner itself so if neccisary we can call functions on it from input fields and other things that the site data is passed to
    userContext:UserContext,
    imageUrls: string[];
    isMultiLocation:boolean,
    locations:LocationData[],
    productPageId:string,
    logoUrl?:string,
    savedSections:string [],
    businessTabs:BusinessValidTabs,
    isMultipleLocation?:boolean,
    isPromoCodeAddressBusiness?:boolean,
    azContainer?: string,
    azContainerURL?: string,
    groupMysite?:number


}

export type LocationData = {
  businessName: string;
  encBID: string;
  encryptionCode: string;
  groupId: string;
  isActive: boolean;
  isMultilocationGroup: boolean;
  isUnderMaintenance: boolean;
  multiLocationGroupID: number;
  shopOwnerID: number;
  total_count: number;
  userType: string;
  vagaroURL: string;
};
//Represents the data that is used to build the site
export type PageData = {
    name:string,
    url:string,
    pageId:string,
    children?:PageData[]
    isDisabled:boolean,
    content?:string,
    nested?:boolean,
    titleTag?:string,
    folderId?:string,
    openGraphImageUrl:string,
    metaDescription?:string,
    isFolder?:boolean,
    order?:0,
    isLandingPage:boolean,
    isHidePage:boolean,
    isDuplicateAllLocationPage:boolean,
    isExternalLink?:boolean,
    isExternalLinkNewTab?:boolean,
}



//Represents the data that is returned from the API
export type RawPageData = {
  content: string;
  description: string;
  folderName: string;
  id: string;
  isFolder: false;
  pageId: string;
  pageName: string;
  pageOrder: 0;
  titleTag: string;
  urlSlug: string;
};


export const tempPageLayoutString = `{"id":"tebcf183560d3382bed95c22215182e3","typename":"PageRoot","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"Ta84fb61449cb2b1ae9fbe5cf3d68d46","screenSizeStyleAttributes":[{"height":"303px"},{"height":"252px"},{}],"componentAttributes":{},"typename":"navigationBar","content":"Your Text Here","children":[{"id":"Vd321bef2bc5d75dbcb4637f7283fd03","screenSizeStyleAttributes":[{"gap":"4px","backgroundColor":"#008a6e","height":"100%"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"flex-end"},"typename":"Column","content":"Your Text Here","children":[{"id":"Obf0127758671c63a3235225ebbec59a","screenSizeStyleAttributes":[{"width":"196px","height":"164px"},{"width":"137px","height":"129px"},{"display":"none"}],"componentAttributes":{},"typename":"Image","content":"Your Text Here","children":[],"renderChildren":true},{"id":"re8d9754b0f3377bb0a626f4369b6b3c","screenSizeStyleAttributes":[{"height":"23px"},{},{"display":"none"}],"componentAttributes":{},"typename":"Spacer","content":"Your Text Here","children":[],"renderChildren":true},{"id":"q2b536298e7d28d4a1f0409e8b2ba859","screenSizeStyleAttributes":[{"justifyContent":"center","gap":"72px","width":"100%","color":"#ffffff","height":"52px"},{},{}],"componentAttributes":{"hoverColor":"#ffbe33","dropdownBackground":"#008a6e"},"typename":"navigationList","content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true}],"renderChildren":true},{"id":"k7eef639c99b600eb73dbb1f983c2a5f","typename":"Section","screenSizeStyleAttributes":[{"gap":"4px"},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"mc331b42ea2454459d0886a44618de4a","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"ue60cf08310e904d81b47e963078fde1","typename":"Image","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"imageSrc":"https://www.shutterstock.com/image-photo/birds-eye-view-pine-forest-600w-2239370259.jpg"},"content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true},{"id":"o19db12d431f6f6d9d5a3471a37f8cb6","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"bec33a0008ecd84da830ec7f0ca8477d","typename":"Image","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"imageSrc":"https://www.shutterstock.com/image-photo/close-photo-still-life-magical-600w-2293988207.jpg"},"content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true}],"renderChildren":true},{"id":"jef6fca4571d8af9a290e5f0c979b36a","typename":"Section","screenSizeStyleAttributes":[{"gap":"4px"},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"h40e093ce174f679b4038876db7f3f4e","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"bbe05292ae22fd9da48bad55c0589bbe","typename":"Image","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"imageSrc":"https://www.shutterstock.com/image-photo/summer-product-photo-beautiful-woman-600w-2297530011.jpg"},"content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true},{"id":"d3a2a1f41ef2c07fb07a04af1783c56a","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"e2edab128a0c1d84a8f4d040ef8271e0","typename":"Image","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"imageSrc":"https://www.shutterstock.com/image-photo/photo-raccoon-owl-600w-2273921985.jpg"},"content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true}],"renderChildren":true},{"id":"Ncdef68dcccaf9e4be9240c571de6221","typename":"footer","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true}`;


export const DefaultSiteData: SiteData = {

    siteName: 'Test Site',
    currentPageId:"",
    lastPublishDate: "",
    userContext: {
        businessId: "",
        styleId: "",
        encUserId:"",
        layoutId: "",
        accessToken: "",
        userId:0,
        pages: [],
        userType: 1,
        imageMapping: [],
        cdnURL: "",
        MultilocationData : [],
        isMysite : false,
        bidHash: ""
    },
    editorSettings: {
        editColorIndex: 0,
        showAddSectionButtons: true,
        promptForTemplates: true,
        autoExpandCollapseRightMenu:true,
        autoSaveFrequency: 10,
        //layoutMode: false,
        opimizeRendering:false,
        advancedMenuIsModular:false,
        disableAnimations: false,
        autoSave: true,
        dragSensitivity: 8,
    },
    prevFooter:"",
    prevHeader:"",

    cdnUrl:"",
    AdminCDNURL:"",
    designer:null,
    pages: [],
    homePageId:"",

    imageCache:new ImageCache(),
    isMultiLocation:false,
    locations:[],
    productPageId:"",
    isViewAllowed:false,
    isModifyAllowed:true,

    businessTabs:{
      isPackageShow: true,
      isShowBookNowTab: true,
      isShowClassTab: true,
      isShowGCTab:  true,
      isShowMembership:  true,
      isShowProductTab: true,
      isShowServiceTab: true,
      isShowDailyDeals: true,
    },

    siteStyling: {
      link: new AttributeCollection({color:"var(--theme-color-1)",textDecoration:"underline"}),
      misc: new AttributeCollection(),
      buttonPrimary: new AttributeCollection({color:"var(--theme-color-1)",backgroundColor:"var(--theme-color-3)"}),
      buttonSecondary: new AttributeCollection({color:"var(--theme-color-1)",backgroundColor:"var(--theme-color-5)"}),
      buttonTertiary: new AttributeCollection({color:"var(--theme-color-2)",backgroundColor:"var(--theme-color-6)"}),

      paragraph1: new AttributeCollection(),
      paragraph2: new AttributeCollection(),
      paragraph3: new AttributeCollection(),

      heading1: new AttributeCollection(),
      heading2: new AttributeCollection(),
      heading3: new AttributeCollection(),
      heading4: new AttributeCollection(),

      headerStyles: new AttributeCollection(),
      paragraphStyles: new AttributeCollection(),

      pageWidth: new AttributeCollection(),
      pageColor: new AttributeCollection({},{"pageColor":"var(--theme-color-5)","pageFontColor":"var(--theme-color-1)"}),
      announcementBar: new AttributeCollection(),
      cookieBanner: new AttributeCollection(undefined,{"cookieBannerText":defaultCookieBannerText}),
      popup: new AttributeCollection({},{"pop-completion-link":"dismiss","pop-main-btn-link":"dismiss"},wBComponentTypeNames.popup),
      colorPallet: [
        "#242424",//darkest
        "#383838",//dark
        "#BEBEBE",//medium
        "#E9E9E9",//light
        "#F6F6F6",//lightest
        "#FFFFFF",//white
        "#D5D5D5",//light gray
        "#868686",//medium gray
        "#464646",//dark gray
        "#000000"//black


      ],
      blogInfo: new AttributeCollection(),
      customFonts: [],

      useFontScaling: false,
      desktopFontSize: 16,
      tabletFontSize: 16,
      mobileFontSize: 16,


      fontPrimary: "Montserrat",
      fontSecondary: "proxima-nova",
      imageMapping: []
    },
    savedSections: [],
    onUpdateStyle: () => { },
    onUpdateCustomCSS: () => { },

    imageUrls: [
        "https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/vagaro-logo-new.svg",


    ],

    azContainer: "",
    azContainerURL: "",

    title: ""
}
